import { useLang } from '../LangContext';

const LANGS = [
  { key: 'zh', label: '中文' },
  { key: 'en', label: 'EN'   },
  { key: 'ja', label: '日本語' },
];

/**
 * LangSwitcher
 * Renders three pill buttons for zh / en / ja.
 * Active: white bg, primary-orange text.
 * Inactive: transparent, white border, white text.
 */
export default function LangSwitcher() {
  const { lang, setLang } = useLang();

  return (
    <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
      {LANGS.map(({ key, label }) => {
        const active = lang === key;
        return (
          <button
            key={key}
            onClick={() => setLang(key)}
            style={{
              padding: '2px 10px',
              borderRadius: '9999px',
              border: active ? 'none' : '1px solid rgba(255,255,255,0.8)',
              background: active ? '#ffffff' : 'transparent',
              color: active ? '#FF5C35' : '#ffffff',
              fontSize: '10px',
              fontWeight: active ? 700 : 500,
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              cursor: 'pointer',
              transition: 'all 0.15s',
              lineHeight: 1.6,
              whiteSpace: 'nowrap',
            }}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}
